import { ShopService } from './../../../data/repository/shop-repository/shop.service';
import { Component, OnInit } from '@angular/core';
import { PromotionpopupService } from './promotionpopup.service';
@Component({
  selector: 'app-promotionpopup',
  templateUrl: './promotionpopup.component.html',
  styleUrls: ['./promotionpopup.component.scss'],
})
export class PromotionpopupComponent implements OnInit {
  constructor(
    private promotionpopupService: PromotionpopupService,
    private shopService: ShopService
  ) {}

  ngOnInit() {}
  close() {
    this.promotionpopupService.close();
  }
  goShop() {
    this.shopService.goToShopPage('profile');
  }
}
